<ng-container *ngIf="datePickerType !== 'range'">
  <app-relative-date-input [inputTheme]="inputTheme"
                           [ngModel]="relativeOffset"
                           (ngModelChange)="onRelativeOffsetChanged($event)">
  </app-relative-date-input>
  <button (click)="setDatePickerType('range')"
          class="link link-small link--noline d-block w-auto pl-0 mt-0050">or by date range&hellip;
  </button>
</ng-container>

<div *ngIf="datePickerType === 'range'" class="d-flex flexWrap-wrap flexGap-0050">

  <mat-form-field class="mb-0 flexGrow-1"
                  [ngClass]="{'ongray': inputTheme === 'white'}">
    <mat-label>Enter a date range</mat-label>

    <mat-date-range-input [rangePicker]="picker"
                          [formGroup]="range">

      <input matStartDate
              [required]="false"
              (keyup)="setNullOnEmpty($event, 'start')"
              placeholder="Start date"
              formControlName="start">
      <input matEndDate
              [required]="false"
              (keyup)="setNullOnEmpty($event, 'end')"
              placeholder="End date"
              formControlName="end">

    </mat-date-range-input>
    <button matPrefix
            *ngIf="range.touched || hasDateRange"
            mat-icon-button
            (click)="clearDate()"
            aria-label="Clear">
      <mat-icon fontSet="far"
                fontIcon="fa-times"></mat-icon>
    </button>
    <mat-datepicker-toggle matSuffix
                            [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>

  <button (click)="setDatePickerType('relative')"
          class="link link-small link--noline d-block w-auto pl-0 mt-0050">or by target days&hellip;
  </button>
</div>
